import React, { useEffect, useState } from 'react'
import { Container, Row, Col } from 'reactstrap'
import { useLocation, useNavigate } from 'react-router-dom'
import Header from '../components/Header'
import UsersEditCard from '../components/users/UsersEditCard'
import apiLoginService from '../services/apiLoginService'
import '../styles/FormView.css'

function UsersEditView() {
  const navigate = useNavigate()
  const location = useLocation()
  const [editingUser, setEditingUser] = useState(null)
  const [editData, setEditData] = useState({
    role: 'WHOLESALER',
    wholesaler: '',
    password: '',
  })
  const [editErrors, setEditErrors] = useState({})
  const [editSubmitted, setEditSubmitted] = useState(false)
  const [isUpdating, setIsUpdating] = useState(false)
  const [editMessage, setEditMessage] = useState('')

  useEffect(() => {
    if (location.state?.user) {
      const user = location.state.user
      setEditingUser(user)
      setEditData({
        role: user?.role ? String(user.role).toUpperCase() : 'WHOLESALER',
        wholesaler: user?.wholesaler || '',
        password: '',
      })
    } else {
      navigate('/users')
    }
  }, [location, navigate])

  const handleEditChange = (event) => {
    const { name, value } = event.target
    setEditData((prev) => ({
      ...prev,
      [name]: value,
    }))

    if (editErrors[name]) {
      setEditErrors((prev) => ({
        ...prev,
        [name]: '',
      }))
    }
  }

  const validateEditForm = () => {
    const newErrors = {}
    if (!editData.role) {
      newErrors.role = 'El rol es requerido'
    }
    return newErrors
  }

  const handleEditSubmit = async (event) => {
    event.preventDefault()
    setEditSubmitted(true)
    setEditMessage('')

    const newErrors = validateEditForm()
    if (Object.keys(newErrors).length > 0) {
      setEditErrors(newErrors)
      return
    }

    if (!editingUser?.id) {
      setEditMessage('No hay usuario seleccionado.')
      return
    }

    setIsUpdating(true)
    try {
      const payload = {
        role: editData.role,
        wholesaler: editData.role === 'WHOLESALER' ? (editData.wholesaler || null) : null,
      }
      if (editData.password && editData.password.trim()) {
        payload.password = editData.password
      }

      await apiLoginService.updateUser(editingUser.id, payload)
      navigate('/users')
    } catch (error) {
      const message = error?.body?.message || 'No se pudo actualizar el usuario.'
      setEditMessage(message)
    } finally {
      setIsUpdating(false)
    }
  }

  return (
    <>
      <Header />
      <Container fluid className="form-container">
        <Container>
          <div className="form-header">
            <h1>Usuarios</h1>
          </div>
          <Row className="justify-content-center">
            <Col xs={12} md={8} lg={6}>
              <UsersEditCard
                editingUser={editingUser}
                editData={editData}
                editErrors={editErrors}
                editSubmitted={editSubmitted}
                isUpdating={isUpdating}
                editMessage={editMessage}
                onChange={handleEditChange}
                onSubmit={handleEditSubmit}
                onCancel={() => navigate('/users')}
              />
            </Col>
          </Row>
        </Container>
      </Container>
    </>
  )
}

export default UsersEditView
